module.exports = __webpack_public_path__ + "image/TA_logo1.png";